<template>
  <div class="quiz_detail_content">
    <div class="card_panel">
      <p class="title">{{ title }}</p>
      <happy-scroll hide-horizontal
                    size="8"
                    resize
                    color="#D8D8D8"
                    style="max-height: 150px; height: auto;">
        <div class="content"
             v-html="description || '暂无描述'"></div>
      </happy-scroll>
      <div class="setting_content">
        <van-divider />
        <van-row style="margin-top: 30px;">
          <van-col span="4">
            <p class="group_title">显示状态</p>
          </van-col>
          <van-col span="20">
            <van-radio-group v-model="visible">
              <van-radio icon-size="28"
                         class="radio"
                         :name="1"
                         checked-color="#FFBD00">显示</van-radio>
              <van-radio icon-size="28"
                         class="radio"
                         :name="0"
                         checked-color="#FFBD00">隐藏</van-radio>
            </van-radio-group>
          </van-col>
        </van-row>
        <van-row style="margin-top: 20px; margin-bottom: 60px;"
                 type="flex"
                 justify="center">
          <!-- <van-col span="6"
                   class="click_able"
                   @click="confirm">
            <div class="button release">立即发布</div>
          </van-col> -->
          <van-col span="6"
                   class="click_able"
                   @click="save">
            <div class="button release">保存</div>
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import course from "@/api/course/index";
import utils from "@/utils/index";
import "@vant/touch-emulator";
import {
  Divider,
  Row,
  Col,
  Checkbox,
  RadioGroup,
  Radio,
  Dialog,
  Toast,
} from "vant";
Vue.use(Divider)
  .use(Row)
  .use(Col)
  .use(Checkbox)
  .use(RadioGroup)
  .use(Radio)
  .use(Dialog);
export default {
  components: {},
  data () {
    return {
      forumid: "",
      visible: "0",
      checkBox: [],
      title: "",
      description: "",
      canEdit: true,
    };
  },
  methods: {
    handleError (error) {
      console.log("error", error);
    },
    async saveAction (isPush = false) {
      const _this = this;
      let result = await course.editForum({
        params: {
          title: this.title,
          intro: this.description,
          forumid: this.forumid,
          visible: this.visible,
          groupmode: 2
        },
        loadingText: "正在保存测验信息",
        errorFn: this.handleError,
      });
      if (result) {
        Toast.success({
          message: "保存成功",
          onClose: () => {
            if (isPush) {
              _this.$router.replace({
                path: "/forum",
                query: {
                  fid: this.forumid
                },
              });
            } else {
              this.$router.go(-1);
            }
          },
        });
      }
    },
    save () {
      const _this = this;
      Dialog.confirm({
        title: "提示",
        message: "确定要保存此讨论更改吗？",
      })
        .then(() => {
          _this.saveAction();
        })
        .catch(() => { });
    },
    confirm () {
      const _this = this;
      Dialog.confirm({
        title: "提示",
        message: "确定要发布此讨论吗？",
      })
        .then(() => {
          _this.visible = 0;
          _this.saveAction(true);
        })
        .catch(() => { });
    },
    async getForumData () {
      let { courseId } = this.$store.state.course;
      let result = await course.getForumsByCourseids({
        params: { courseids: [courseId] },
        loadingText: "讨论详情信息",
        errorFn: this.handleError,
      });
      if (result) {
        console.log('result', result)
        const { intro, name } = result.filter(
          (v) => v.id === this.forumid
        )[0];
        this.title = name;
        this.description = intro
        console.log("forum", intro, name);
        this.title = name;
      }
    },
  },
  mounted () {
    let { fid, vis } = this.$route.query
    if (fid) {
      this.forumid = parseInt(fid);
      console.warn("vis", vis);
      this.visible = parseInt(vis)
      this.getForumData();
    } else {
      Dialog.alert({
        title: '提示',
        message: '获取数据失败，请返回讨论区列表重新进入页面'
      }).then(() => {
        this.$router.go(-1)
      })
    }
  },
};
</script>
<style lang="less" scoped>
.flex-row {
  display: flex;
  width: 100%;
}
.checked {
  font-size: 18px;
  padding-left: 10px;
}
.quiz_detail_content {
  height: 100%;
  position: relative;
  padding: 50px 160px;
  z-index: 9;
  .card_panel {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
    border-radius: 48px;
    padding: 60px;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    .title {
      word-break: break-all;
      font-size: 54px;
      font-weight: bold;
      color: #333;
      padding-right: 15px;
      margin-bottom: 20px;
    }
    .content {
      font-size: 24px;
      line-height: 30px;
      color: #6c6c6c;
    }
    .happy-scroll-content {
      width: 100%;
      overflow-y: auto;
      max-height: 80px;
    }
    .setting_content {
      .group_title {
        font-size: 24px;
      }
      .quiz_title {
        color: #37ab7e;
        font-size: 24px;
        font-weight: bold;
      }
      .list_title {
        color: #333;
        font-size: 24px;
        &.time-value {
          border: none;
          background: none;
          &.disabled {
            color: #a6a6a6;
          }
        }
      }
      .radio {
        margin-bottom: 20px;
        font-size: 24px;
      }
      .button {
        padding: 20px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        font-weight: bold;
        border-radius: 40px;
        color: #ffffff;
      }
      .release {
        background: #37ab7e;
        border: 2px solid rgba(55, 171, 126, 1);
      }
      .quit {
        background: #ffffff;
        color: #37ab7e;
        border: 2px solid rgba(55, 171, 126, 1);
      }
    }
  }
}
</style>